import { API_BASE, ApiError, request } from './core.api';

export interface TenantSatisfactionSurveyDto {
  id: string;
  tenantId: string;
  year: number;
  sentAt: string;
  answeredAt?: string | null;
  rating?: number | null;
  comment?: string | null;
}

export interface SurveyPublicInfoDto {
  tenantFirstName: string;
  landlordDisplayName: string;
  year: number;
  isAnswered: boolean;
}

export interface SubmitSatisfactionSurveyRequest {
  rating: number;
  comment?: string | null;
}

export const satisfactionSurveysApi = {
  getByTenant: (tenantId: string) =>
    request<TenantSatisfactionSurveyDto[]>(`/tenants/${tenantId}/surveys`),

  sendToTenant: (tenantId: string) =>
    request<TenantSatisfactionSurveyDto>(`/tenants/${tenantId}/surveys/send`, { method: 'POST' }),

  getByToken: async (token: string): Promise<SurveyPublicInfoDto | null> => {
    const response = await fetch(`${API_BASE}/surveys/${encodeURIComponent(token)}`);
    if (response.status === 404) return null;
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return response.json();
  },

  submit: async (token: string, body: SubmitSatisfactionSurveyRequest): Promise<void> => {
    const response = await fetch(`${API_BASE}/surveys/${encodeURIComponent(token)}/submit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({ error: 'Onbekende fout' }));
      throw new ApiError(err.error || `HTTP ${response.status}`, response.status, err.code, err.details);
    }
  },
};
